/* Shared by the sign-in and logout flows so there is one allowlist, not two that can drift. */
export const isAllowedUaePassUrl = (url: string): boolean => {
    try {
        const parsed = new URL(url);
        return (
            parsed.protocol === 'https:' &&
            parsed.hostname.endsWith('.uaepass.ae')
        );
    } catch {
        return false;
    }
};
